// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.draggable-container .dragging[data-v-4d64a060] {\n    opacity: 0.5;\n}\n.draggable-container .is-disabled > *[data-v-4d64a060] {\n    pointer-events: none;\n}\n.drag-above[data-v-4d64a060], .drag-below[data-v-4d64a060] {\n    display: inline-block;\n    width:100%;\n    height: 1rem;\n}\n  ", ""]);
// Exports
module.exports = exports;
